import React, { useEffect, useState } from 'react';
import baseURL from '../../url';
import './ReservasData.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUserTie,
    faUser,
    faPhone,
    faCalendarAlt,
    faFilter,
    faPlus,
    faTimes,
    faSearch
} from '@fortawesome/free-solid-svg-icons';

const diasSemanaMap = {
    0: "domingo",
    1: "lunes",
    2: "martes",
    3: "miercoles",
    4: "jueves",
    5: "viernes",
    6: "sabado",
};

export default function ReservasData() {
    const [eventos, setEventos] = useState([]);
    const [turnoSeleccionado, setTurnoSeleccionado] = useState(null);
    const [profesionales, setProfesionales] = useState([]);
    const [fechasNoDisponibles, setFechasNoDisponibles] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [productos, setProductos] = useState([]);
    const [producto, setProducto] = useState(null);
    const [productosServicios, setProductosServicios] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [reservas, setReservas] = useState([]);

    // Filtros
    const [filtroNombre, setFiltroNombre] = useState("");
    const [filtroProfesional, setFiltroProfesional] = useState("");
    const [filtroTelefono, setFiltroTelefono] = useState("");
    const [filtroFechaInicio, setFiltroFechaInicio] = useState("");
    const [filtroFechaFin, setFiltroFechaFin] = useState("");
    const [filtroProducto, setFiltroProducto] = useState("");

    // Modal States
    const [modalOpen, setModalOpen] = useState(false);
    const [nombre, setNombre] = useState("");
    const [noteText, setNoteText] = useState("");
    const [telefono, setTelefono] = useState("");
    const [productoId, setProductoId] = useState("");
    const [pago, setPago] = useState(null);
    
    const [profesionalSeleccionadoId, setProfesionalSeleccionadoId] = useState("");
    const [diaSeleccionado, setDiaSeleccionado] = useState(new Date());

    const listaDias = Array.from({ length: 21 }, (_, i) => {
        const d = new Date();
        d.setDate(d.getDate() + i);
        return d;
    });

    const obtenerTurnosDiaSeleccionado = () => {
        return eventos.filter(evt => {
            const dEvt = new Date(evt.start);
            return dEvt.getFullYear() === diaSeleccionado.getFullYear() &&
                   dEvt.getMonth() === diaSeleccionado.getMonth() &&
                   dEvt.getDate() === diaSeleccionado.getDate();
        });
    };

    const handleTurnoClick = (evt) => {
        if (evt.extendedProps?.ocupado) return;
        setTurnoSeleccionado({
            id: evt.id,
            start: evt.start,
            end: evt.end,
            profesionalId: evt.extendedProps.profesionalId,
            profesionalNombre: evt.extendedProps.profesionalNombre
        });
    };

    // Estado para reservas seleccionadas
    const [selectedReservas, setSelectedReservas] = useState([]);

    useEffect(() => {
        cargarCategoria();
        cargarProductos();
        cargarMetodosPago();
        cargarReservas();
        cargarProfesionales();
    }, []);

    function cargarCategoria() {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(res => res.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(err => console.error(err));
    }

    function cargarProductos() {
        fetch(`${baseURL}/productosGet.php`)
            .then(res => res.json())
            .then(data => setProductos(data.productos || []))
            .catch(err => console.error(err));
    }

    function cargarMetodosPago() {
        fetch(`${baseURL}/paymentMethodsGet.php?only_active=1`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setPaymentMethods(data.payment_methods || []);
                    if (data.payment_methods.length > 0) setPago(data.payment_methods[0]);
                }
            });
    }

    function cargarReservas() {
        fetch(`${baseURL}/pedidoGetReservas.php`)
            .then(res => res.json())
            .then(data => {
                const pedidos = data.pedidos || [];
                setReservas(pedidos.map(p => {
                    let text = "";
                    try {
                        const arr = typeof p.productos === "string" ? JSON.parse(p.productos) : p.productos;
                        text = Array.isArray(arr) ? arr.map(pr => pr.titulo || pr.name || pr.idProducto).join(", ") : String(p.productos);
                    } catch { text = String(p.productos); }
                    return { ...p, productosText: text };
                }));
            });
    }

    function cargarProfesionales() {
        fetch(`${baseURL}/profesionalesGet.php`)
            .then(res => res.json())
            .then(data => setProfesionales(data.profesionales || []));
    }

    function cargarFechasNoDisponibles(idProducto) {
        fetch(`${baseURL}/getProductoReservas.php?idProducto=${idProducto}`)
            .then(res => res.json())
            .then(data => {
                if (data.success && Array.isArray(data.reservas)) {
                    setFechasNoDisponibles(data.reservas.map(r => ({
                        start: new Date(r.start),
                        end: new Date(r.end),
                        pid: r.pid
                    })));
                }
            });
    }

    const limpiarFiltros = () => {
        setFiltroNombre(""); setFiltroProfesional(""); setFiltroTelefono("");
        setFiltroFechaInicio(""); setFiltroFechaFin(""); setFiltroProducto("");
    };

    const reservasFiltradas = reservas.filter(r => {
        const matchNombre = (r.nombre || "").toLowerCase().includes(filtroNombre.toLowerCase());
        const matchProf = (r.profesional_nombre || "").toLowerCase().includes(filtroProfesional.toLowerCase());
        const matchTel = filtroTelefono ? (r.telefono || "").toString().includes(filtroTelefono) : true;
        const matchProd = filtroProducto ? (r.productosText || "").toLowerCase().includes(filtroProducto.toLowerCase()) : true;
        
        let matchFecha = true;
        if (filtroFechaInicio || filtroFechaFin) {
            const fStart = r.startDate ? r.startDate.slice(0, 10) : null;
            if (!fStart) matchFecha = false;
            else {
                const cond1 = filtroFechaFin ? fStart <= filtroFechaFin : true;
                const cond2 = filtroFechaInicio ? fStart >= filtroFechaInicio : true;
                matchFecha = cond1 && cond2;
            }
        }
        return matchNombre && matchProf && matchTel && matchProd && matchFecha;
    });

    const formatearFecha = (fecha) => {
        if (!fecha) return "-";
        const f = new Date(fecha);
        return isNaN(f.getTime()) ? fecha : f.toLocaleDateString('es-ES');
    };

    const formatDateHour = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit", hour12: false });
    };


    // GENERACIÓN DE EVENTOS (Solo si hay producto Y profesional seleccionado)
    useEffect(() => {
        if (producto?.dias && profesionalSeleccionadoId && profesionales.length > 0) {
            let configGlobal = typeof producto.dias === "string" ? JSON.parse(producto.dias) : producto.dias;
            const nuevosEventos = [];
            const hoy = new Date();
            hoy.setHours(0,0,0,0);

            const profId = profesionalSeleccionadoId;
            const profData = profesionales.find(p => p.id == profId);
            const diasTrabajo = configGlobal[profId];

            if (diasTrabajo) {
                let demora = 60;
                try {
                    const dJ = JSON.parse(producto.demora);
                    if(dJ[profId]) demora = parseInt(dJ[profId]);
                } catch(e) {}

                for (let i = 0; i < 21; i++) {
                    const fecha = new Date(hoy);
                    fecha.setDate(hoy.getDate() + i);
                    const diaNombre = diasSemanaMap[fecha.getDay()];
                    const diaConfig = diasTrabajo[diaNombre];

                    if (diaConfig?.turnos) {
                        diaConfig.turnos.forEach(t => {
                            if (t.activo === false) return;
                            const [h, m] = t.hora.split(":");
                            const start = new Date(fecha);
                            start.setHours(h, m, 0, 0);
                            const end = new Date(start.getTime() + demora * 60000);

                            const ocupado = fechasNoDisponibles.some(r => 
                                (start < r.end && end > r.start) && (r.pid === null || parseInt(r.pid) === parseInt(profId))
                            );

                            nuevosEventos.push({
                                id: `p${profId}_${start.getTime()}`,
                                title: ocupado ? `Ocupado` : `${profData?.nombre}`,
                                start, end,
                                backgroundColor: ocupado ? "#dc3545" : "#28a745",
                                borderColor: ocupado ? "#dc3545" : "#28a745",
                                extendedProps: { profesionalId: profId, profesionalNombre: profData?.nombre, ocupado }
                            });
                        });
                    }
                }
            }
            setEventos(nuevosEventos);
        } else {
            setEventos([]);
        }
    }, [producto, profesionalSeleccionadoId, fechasNoDisponibles, profesionales]);

    useEffect(() => {
        if (categorias.length > 0 && productos.length > 0) {
            const idsServicio = categorias.filter(cat => cat.categoria.toLowerCase().includes("servicio")).map(cat => cat.idCategoria);
            setProductosServicios(productos.filter(prod => idsServicio.includes(prod.idCategoria)));
        }
    }, [categorias, productos]);

    const handleGuardarReserva = async (e) => {
        e.preventDefault();
        if (!nombre || !producto || !turnoSeleccionado) return alert("Complete todos los pasos (Cliente, Servicio, Profesional y Turno)");

        const formatLocal = (date) => {
            const pad = (n) => n.toString().padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
        };

        const productosPedido = [{
            tipo: "reserva",
            idProducto: producto.idProducto,
            fecha_inicio: formatLocal(turnoSeleccionado.start),
            fecha_fin: formatLocal(turnoSeleccionado.end),
            cantidad: 1,
            titulo: producto.titulo,
            profesionalId: turnoSeleccionado.profesionalId,
            profesionalNombre: turnoSeleccionado.profesionalNombre,
            items: []
        }];

        const formData = new FormData();
        formData.append("startDate", productosPedido[0].fecha_inicio);
        formData.append("finishDate", productosPedido[0].fecha_fin);
        formData.append("productos", JSON.stringify(productosPedido));
        formData.append("total", producto.precio);
        formData.append("nombre", nombre);
        formData.append("telefono", telefono);
        formData.append("nota", noteText);
        formData.append("codigo", "");
        formData.append("profesionalId", turnoSeleccionado.profesionalId);
        formData.append("profesionalNombre", turnoSeleccionado.profesionalNombre);
        formData.append("estado", "Reservado");
        formData.append("pago", pago?.name || 'Efectivo');
        formData.append("entrega", "Reserva servicio");

        try {
            const response = await fetch(`${baseURL}/pedidoPostWithPayment.php`, {
                method: "POST",
                body: formData
            });
            const data = await response.json();
            if (data.mensaje) {
                alert("Reserva creada con éxito");
                setModalOpen(false);
                setNombre(""); setTelefono(""); setProductoId(""); setProfesionalSeleccionadoId("");
                setTurnoSeleccionado(null);
                setDiaSeleccionado(new Date());
                cargarReservas();
            } else {
                alert(data.error || "Error al guardar");
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteSelected = async () => {
        if (selectedReservas.length === 0) return alert("Seleccione al menos una reserva para eliminar.");
        if (window.confirm("¿Está seguro de que desea eliminar las reservas seleccionadas?")) {
            try {
                const promises = selectedReservas.map(id => 
                    fetch(`${baseURL}/pedidoDelete.php?idPedido=${id}`, { method: 'DELETE' })
                );
                await Promise.all(promises);
                alert("Reservas eliminadas correctamente.");
                setSelectedReservas([]);
                cargarReservas();
            } catch (err) {
                console.error("Error eliminando reservas", err);
                alert("Hubo un error al eliminar las reservas.");
            }
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedReservas(reservasFiltradas.map(r => r.idPedido));
        } else {
            setSelectedReservas([]);
        }
    };

    const handleSelectReserva = (idPedido, checked) => {
        if (checked) {
            setSelectedReservas(prev => [...prev, idPedido]);
        } else {
            setSelectedReservas(prev => prev.filter(id => id !== idPedido));
        }
    };

    return (
        <div className="containerReservas">
            <h2 className="mb-3">Reservas</h2>

            <div className="filtrosReservas">
                <div className="filtroItem">
                    <FontAwesomeIcon icon={faUser} className="iconoFiltro" />
                    <input type="text" className="inputFiltro" placeholder="Cliente" value={filtroNombre} onChange={e => setFiltroNombre(e.target.value)} />
                </div>
                <div className="filtroItem">
                    <FontAwesomeIcon icon={faUserTie} className="iconoFiltro" />
                    <input type="text" className="inputFiltro" placeholder="Profesional" value={filtroProfesional} onChange={e => setFiltroProfesional(e.target.value)} />
                </div>
                <div className="filtroItem">
                    <FontAwesomeIcon icon={faPhone} className="iconoFiltro" />
                    <input type="text" className="inputFiltro" placeholder="Teléfono" value={filtroTelefono} onChange={e => setFiltroTelefono(e.target.value)} />
                </div>
                <div className="filtroItem">
                    <FontAwesomeIcon icon={faCalendarAlt} className="iconoFiltro" />
                    <input type="date" className="inputFiltroFecha" value={filtroFechaInicio} onChange={e => setFiltroFechaInicio(e.target.value)} />
                </div>
                <div className="filtroItem">
                    <FontAwesomeIcon icon={faCalendarAlt} className="iconoFiltro" />
                    <input type="date" className="inputFiltroFecha" value={filtroFechaFin} onChange={e => setFiltroFechaFin(e.target.value)} />
                </div>
                <button className="btnLimpiarFiltros" onClick={limpiarFiltros}><FontAwesomeIcon icon={faFilter} /> Limpiar</button>
                <button className="btnLimpiarFiltros" onClick={() => setModalOpen(true)}>
                    <FontAwesomeIcon icon={faPlus} /> Carga manual
                </button>
                {selectedReservas.length > 0 && (
                    <button className="btnLimpiarFiltros" style={{backgroundColor: '#dc3545', color: 'white'}} onClick={handleDeleteSelected}>
                        Eliminar seleccionados
                    </button>
                )}
            </div>

            <div className="tablaReservasContainer">
                <table className="tablaReservas">
                    <thead>
                        <tr>
                            <th>
                                <input 
                                    type="checkbox" 
                                    onChange={handleSelectAll} 
                                    checked={reservasFiltradas.length > 0 && selectedReservas.length === reservasFiltradas.length} 
                                />
                            </th>
                            <th>ID</th><th>Cliente</th><th>Profesional</th><th>Producto</th><th>Día</th><th>Turno</th><th>Pago</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reservasFiltradas.map(r => (
                            <tr key={r.idPedido}>
                                <td>
                                    <input 
                                        type="checkbox" 
                                        checked={selectedReservas.includes(r.idPedido)} 
                                        onChange={(e) => handleSelectReserva(r.idPedido, e.target.checked)}
                                    />
                                </td>
                                <td>{r.idPedido}</td>
                                <td>{r.nombre}</td>
                                <td>{r.profesional_nombre}</td>
                                <td>{r.productosText}</td>
                                <td>{formatearFecha(r.startDate)}</td>
                                <td>{formatDateHour(r.startDate)} - {formatDateHour(r.finishDate)}</td>
                                <td>{r.pago}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {modalOpen && (
                <div className="modalOverlay">
                    <div className="modalContent" style={{ maxWidth: '900px' }}>
                        <div className="modalHeader">
                            <h3>Nueva Reserva Manual</h3>
                            <button className="closeBtn" onClick={() => setModalOpen(false)}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <form className="modalForm" onSubmit={handleGuardarReserva}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                <div>
                                    <label>Nombre del Cliente:</label>
                                    <input type="text" value={nombre} onChange={e => setNombre(e.target.value)} required />
                                </div>
                                <div>
                                    <label>Teléfono:</label>
                                    <input type="text" value={telefono} onChange={e => setTelefono(e.target.value)} />
                                </div>
                            </div>

                            <label style={{marginTop: '10px'}}>1. Seleccionar Servicio:</label>
                            <select value={productoId} onChange={(e) => {
                                let p = productosServicios.find(x => x.idProducto.toString() === e.target.value);
                                setProducto(p); 
                                setProductoId(e.target.value);
                                setProfesionalSeleccionadoId(""); // Reset al cambiar producto
                                setTurnoSeleccionado(null);
                                if (p) cargarFechasNoDisponibles(p.idProducto);
                            }} required>
                                <option value="">Elija un servicio...</option>
                                {productosServicios.map(p => <option key={p.idProducto} value={p.idProducto}>{p.titulo}</option>)}
                            </select>

                            {producto && (
                                <>
                                    <label style={{marginTop: '10px'}}>2. Seleccionar Profesional:</label>
                                    <select 
                                        value={profesionalSeleccionadoId} 
                                        onChange={(e) => {
                                            setProfesionalSeleccionadoId(e.target.value);
                                            setTurnoSeleccionado(null);
                                        }} 
                                        required
                                    >
                                        <option value="">Elija quién atenderá...</option>
                                        {profesionales
                                            .filter(prof => {
                                                try {
                                                    if (!prof.categorias) return false;
                                                    const cats = typeof prof.categorias === 'string' ? JSON.parse(prof.categorias) : prof.categorias;
                                                    if (!Array.isArray(cats)) return false;
                                                    return cats.some(c => c.toString() === producto.idCategoria.toString());
                                                } catch { return false; }
                                            })
                                            .map(prof => <option key={prof.id} value={prof.id}>{prof.nombre}</option>)
                                        }
                                    </select>
                                </>
                            )}

                            {profesionalSeleccionadoId && (
                                <div style={{ marginTop: '15px' }}>
                                    <label>3. Seleccionar Turno disponible:</label>
                                    <div className="admin-dias-scroll">
                                        {listaDias.map((date, idx) => {
                                            const isSelected = diaSeleccionado.toDateString() === date.toDateString();
                                            const diaNombre = diasSemanaMap[date.getDay()];
                                            return (
                                                <div 
                                                    key={idx}
                                                    className={`admin-dia-card ${isSelected ? 'selected' : ''}`}
                                                    onClick={() => {
                                                        setDiaSeleccionado(date);
                                                        setTurnoSeleccionado(null);
                                                    }}
                                                >
                                                    <span className="admin-dia-nombre">{diaNombre === "domingo" ? "dom" : diaNombre.slice(0, 3)}</span>
                                                    <span className="admin-dia-numero">{date.getDate()}</span>
                                                    <span className="admin-dia-mes">{date.toLocaleDateString('es-ES', { month: 'short' }).replace('.', '')}</span>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div className="admin-horas-container">
                                        {obtenerTurnosDiaSeleccionado().length > 0 ? (
                                            <div className="admin-horas-grid">
                                                {obtenerTurnosDiaSeleccionado().map((evt, hIdx) => {
                                                    const ocupado = evt.extendedProps?.ocupado;
                                                    const isSelected = turnoSeleccionado?.id === evt.id;
                                                    const horaStr = new Date(evt.start).toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit", hour12: false });
                                                    return (
                                                        <button 
                                                            key={hIdx}
                                                            type="button"
                                                            disabled={ocupado}
                                                            className={`admin-hora-btn ${isSelected ? 'selected' : ''} ${ocupado ? 'ocupado' : ''}`}
                                                            onClick={() => handleTurnoClick(evt)}
                                                        >
                                                            {horaStr}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <div className="admin-sin-turnos">
                                                No hay turnos configurados o disponibles para este día.
                                            </div>
                                        )}
                                    </div>

                                    {turnoSeleccionado && (
                                        <div className="admin-infoturno">
                                            <strong>Turno Seleccionado:</strong> {new Date(turnoSeleccionado.start).toLocaleDateString()} a las {formatDateHour(turnoSeleccionado.start)} hs.
                                        </div>
                                    )}
                                </div>
                            )}

                            <div style={{ marginTop: '15px' }}>
                                <label>4. Seleccionar Medio de pago:</label>
                                <select value={pago?.idPaymentMethod} onChange={e => setPago(paymentMethods.find(m => m.idPaymentMethod == e.target.value))}>
                                    {paymentMethods.map(m => <option key={m.idPaymentMethod} value={m.idPaymentMethod}>{m.name}</option>)}
                                </select>
                            </div>
                            <div style={{marginTop: '15px', display: 'flex', gap: '10px', alignItems: 'flex-end'}}>
                                <button type="submit" className="btnGuardar" style={{height: '40px'}}>Confirmar Reserva</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}